import React, { useState, useEffect, Fragment } from 'react'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom'
import { Row, Form, Table, Card, ButtonGroup, DropdownButton, Button, Col, Alert } from 'react-bootstrap'
import { connect } from 'react-redux';
import store from 'store/store';
import PropagateLoader from "react-spinners/PropagateLoader";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { toast } from 'react-toastify';
import Select from 'react-select';
import { selectBaseStyles, selectInvalidStyles, requiredIndicator, dictionary, fields_array_normalize, emptyServerError, TinyAPIKey, Tiny_plugins, Tiny_toolbar } from './Config';
import DatePicker from '@amir04lm26/react-modern-calendar-date-picker';
import InputMask from 'react-input-mask';
import { Editor } from '@tinymce/tinymce-react';

function MyForm2(props) {
    const {control, reset, getValues} = props
    const [fields,setFields] = useState()
    
    useEffect(() => {
        // console.log('Run useEffect []',props?.fields)
        emptyServerError()
    }, [])
    
    useEffect(() => {
        setFields(props?.fields)
    }, [props?.fields])

    const handleMultiSelected = (values,func,options) => {
        let selectedArray
        let checkSelectAll = values?.find(item => item.value === 'all')
        if(checkSelectAll !== undefined)
            selectedArray = options?.map(item => item.value)
        else
            selectedArray = values?.map(item => item.value)
        func(selectedArray)
    }

    // const [multipleImages, setMultipleImages] = useState([]);
    // const changeMultipleFiles = (e) => {
    //     let h1 = []
    //     Array.from(e.target.files).forEach(file => { 
    //         h1.push(file)
    //     });
    //     setMultipleImages(h1)
    // }

    const removeDate = (field) => {
        let values = getValues()
        reset({
            ...values,
            [field]: null
        })
    }


    const handleTinyCMEOnchange = (editor,field) => {
        let values = getValues()
        reset({
            ...values,
            [field.name]: editor.getContent()
        })
    }
    

    return (
        <Row>
            {
                props?.fields?.filter(item => item.visibility)?.map((item,index) => {
                    return (
                        <Fragment key={item.id}>
                            <Form.Group 
                                as={Col} 
                                sm={Array.isArray(item.bs_grid) && item.bs_grid[0]}
                                md={Array.isArray(item.bs_grid) && item.bs_grid[1]}
                                lg={Array.isArray(item.bs_grid) && item.bs_grid[2]}
                                xl={Array.isArray(item.bs_grid) && item.bs_grid[3]}
                                xxl={Array.isArray(item.bs_grid) && item.bs_grid[4]}
                                className={item.className}
                            >
                                {
                                    (item.name !== null && item.name !== undefined) &&
                                    <>
                                    {
                                        <>
                                            <Form.Label>
                                                <span>
                                                    {
                                                        item.title 
                                                        ? 
                                                        item.title 
                                                        : 
                                                        props?.fields_dic_prefix
                                                            ?
                                                            dictionary.fields[props?.fields_dic_prefix][item.name]
                                                            :
                                                            dictionary.fields[item.name]
                                                    }
                                                </span>
                                                {
                                                    Array.isArray(item.rules) && item.rules.includes('required') && requiredIndicator
                                                }
                                                {
                                                    item.title_extra
                                                }
                                            </Form.Label>
                                            {
                                                (item.type === 'array_input') &&
                                                <>
                                                {
                                                    (() => {
                                                            let rows = [];
                                                            for (let i = 0; i < item.count+1; i++) {
                                                                rows.push(
                                                                    <Controller
                                                                        key={i}
                                                                        control={control}
                                                                        name={item.name}
                                                                        render={({ field, onChange }) => (
                                                                            <Form.Control 
                                                                                type='input'
                                                                                onChange={(e) => { field.onChange(e) }}
                                                                                value={field.value ? field.value : ''}
                                                                                dir={item.dir}
                                                                                placeholder={
                                                                                    item.title 
                                                                                    ? 
                                                                                    item.title 
                                                                                    : 
                                                                                    props?.fields_dic_prefix
                                                                                        ?
                                                                                        dictionary.fields[props?.fields_dic_prefix][item.name]
                                                                                        :
                                                                                        dictionary.fields[item.name]
                                                                                }
                                                                                isInvalid={props?.errors[item.name]?.message}
                                                                            />
                                                                        )}
                                                                    />
                                                                );
                                                            }
                                                            return rows;
                                                        }
                                                    )()
                                                }
                                                </>
                                            }
                                            {
                                                (item.type === 'input' || item.type === 'textarea' || item.type === 'password') &&
                                                <>
                                                    {   
                                                        <Controller
                                                            control={control}
                                                            name={item.name}
                                                            render={({ field, onChange }) => (
                                                                <Form.Control 
                                                                    type={(item.type === 'input' || item.type === 'textarea') ? "text" : "password"}
                                                                    {
                                                                        ...item.type === 'textarea' &&
                                                                        {as:'textarea'}
                                                                    }
                                                                    rows={item.rows}
                                                                    onChange={(e) => { field.onChange(e) }}
                                                                    value={field.value ? field.value : ''}
                                                                    dir={item.dir}
                                                                    placeholder={
                                                                        item.title 
                                                                        ? 
                                                                        item.title 
                                                                        : 
                                                                        props?.fields_dic_prefix
                                                                            ?
                                                                            dictionary.fields[props?.fields_dic_prefix][item.name]
                                                                            :
                                                                            dictionary.fields[item.name]
                                                                    }
                                                                    isInvalid={props?.errors[item.name]?.message}
                                                                    maxLength={item.maxLength || null}
                                                                />
                                                            )}
                                                        />
                                                    }
                                                </>
                                            }
                                            {
                                                (item.type === 'TinyCME') &&
                                                <Controller
                                                    control={control}
                                                    name={item.name}
                                                    render={({ field }) => (
                                                        <>
                                                        <Editor
                                                            apiKey={ TinyAPIKey }
                                                            onChange={ ( event, editor ) => {
                                                                handleTinyCMEOnchange(editor,field);
                                                            } }
                                                            initialValue={field.value}
                                                            init={{
                                                                height: 300,
                                                                menubar: true,
                                                                statusbar: false,
                                                                plugins: Tiny_plugins,
                                                                toolbar: Tiny_toolbar,
                                                                content_css: "/assets/css/tiny_custom.css",
                                                                // content_style: 'body { font-family:Vazir,Arial,sans-serif; font-size:18px }',
                                                                extended_valid_elements:"style,link[href|rel],i[class],script[src],class,*",
                                                                custom_elements:"style,link,~link,i,class,*",
                                                                font_formats: 'Vazir',
                                                            }}
                                                        />
                                                        </>
                                                    )}
                                                />
                                            }
                                            {
                                                item.type === 'file' &&
                                                <>
                                                    {   
                                                        <Controller
                                                            control={control}
                                                            name={item.name}
                                                            render={({ field, onChange }) => (
                                                                <Form.Control 
                                                                    type="file"
                                                                    rows={item.rows}
                                                                    // onChange={(e) => { field.onChange(e); props?.extraFunctions[item.extra](e);  }}
                                                                    onChange={(e) => { field.onChange(e); props?.extraFunctions[item.extra](e,props?.getValues,props?.reset,item.name);  }}
                                                                    multiple={item.multiple}
                                                                    dir={item.dir}
                                                                    isInvalid={props?.errors[item.name]?.message}
                                                                />
                                                            )}
                                                        />
                                                    }
                                                </>
                                            }
                                            {
                                                item.type === 'input-mask' &&
                                                <>
                                                    {   
                                                        <Controller
                                                            control={control}
                                                            name={item.name}
                                                            render={({ field, onChange }) => (
                                                                <InputMask 
                                                                    mask={item.mask}
                                                                    onChange={(e) => { field.onChange(e) }}
                                                                    value={field.value ? field.value : ''}
                                                                    className={props?.errors[item.name]?.message ? "form-control is-invalid"  : "form-control"}
                                                                    dir="ltr"
                                                                />
                                                            )}
                                                        />
                                                    }
                                                </>
                                            }
                                            {
                                                item.type === 'select' &&
                                                <>
                                                    {
                                                        <Controller
                                                            control={control}
                                                            name={item.name}
                                                            render={({ field }) => (
                                                                <Select
                                                                    value={
                                                                        item.multiple === true
                                                                        ?
                                                                        item.options?.filter(item => field.value?.includes(item.value))
                                                                        :
                                                                        field.value !== null && item.options?.find(item => item.value === field.value)
                                                                    }
                                                                    onChange={
                                                                        item.multiple === true
                                                                        ? 
                                                                        (e) => { 
                                                                                    handleMultiSelected(e,field.onChange,item.options); 
                                                                                    if(item?.extra) { 
                                                                                        // console.log('A:',item.extra,props?.extraFunctions,props?.extraFunctions[item.extra]); 
                                                                                        props?.extraFunctions[item.extra](e,field.onChange,field); 
                                                                                    }
                                                                                }
                                                                        : 
                                                                        e => {
                                                                                field.onChange(e?.value);
                                                                            }
                                                                    }
                                                                    options={item.selectAll ? [{value:'all',label:'انتخاب همه'},...item.options] : item.options}
                                                                    placeholder="انتخاب کنید ..."
                                                                    isMulti={item.multiple}
                                                                    isClearable={true}
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                    styles={{
                                                                        ...(props?.errors[item.name]?.message
                                                                            ? selectInvalidStyles
                                                                            : selectBaseStyles),
                                                                        menuPortal: base => ({
                                                                            ...base,
                                                                            zIndex: 99999999999,
                                                                        }),
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    }
                                                </>
                                            }
                                            {
                                                item.type === 'date' &&
                                                <>
                                                    {
                                                        <>
                                                            <Controller
                                                                control={control}
                                                                name={item.name}
                                                                render={({ field }) => (
                                                                    <DatePicker
                                                                        onChange={field.onChange}
                                                                        value={field.value ? field.value : ''}
                                                                        inputPlaceholder={dictionary?.fields[item.name]}
                                                                        shouldHighlightWeekends
                                                                        locale="fa"
                                                                        // wrapperClassName="my-datepicker-popper"
                                                                        inputClassName={props?.errors[item.name]?.message ? "form-control myDatePicker myDatePickerInvalid" : "form-control myDatePicker"}
                                                                        renderFooter={() => (
                                                                            <div style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                                                                            <button
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    removeDate(item.name)
                                                                                }}
                                                                                style={{
                                                                                    border: '#07bc0c',
                                                                                    color: '#fff',
                                                                                    borderRadius: '0.5rem',
                                                                                    padding: '10px 20px',
                                                                                    backgroundColor:'green',
                                                                                }}
                                                                            >
                                                                                حذف
                                                                            </button>
                                                                            </div>
                                                                        )}
                                                                    />
                                                                )}
                                                            />
                                                        </>
                                                    }
                                                </>
                                            }
                                            {
                                                item.comments?.length > 0 &&
                                                <Form.Control.Feedback type="valid" className="text-info" style={{display:'block'}}>
                                                    {
                                                        item.comments?.map((comment,comment_index) => (
                                                            <p key={comment_index}>{comment}</p>
                                                        ))
                                                    }
                                                </Form.Control.Feedback>
                                            }
                                            {
                                                // item.rules?.length > 0 &&
                                                <Form.Control.Feedback type="invalid" style={{display:'block'}}>
                                                    {props?.errors[item.name]?.message}
                                                </Form.Control.Feedback>
                                            }
                                        </>
                                    }
                                    </>
                                }
                                {
                                    item.type === 'component' &&
                                    <div className="m-1">{item.component}</div>
                                }
                                {
                                    item.type === 'divider' &&
                                    <div className="w-100 m-1"></div>
                                }
                                {
                                    item.type === 'hr' &&
                                    <hr />
                                }
                            </Form.Group>
                        </Fragment>
                    )
                })
            }
            {
                props?.extraComponents 
            }
            {
                props?.children 
            }
        </Row>
    )
}


export default MyForm2;